import { inject, Injectable } from '@angular/core';
import { Repository } from './repository';
import { NotificationsApi } from '../api/notifications-api';
import { PaginationFilter } from 'src/app/shared/interfaces';
import { Observable } from 'rxjs';
import { NotificationsModel } from '../model/notifications-model';

@Injectable({
  providedIn: 'root',
})
export class NotificationsRepository extends Repository {
  constructor(private _notificationsApi: NotificationsApi) {
    super();
  }

  getLatestNotifications(filter: PaginationFilter): Observable<NotificationsModel[]> {
    return this._notificationsApi.getLatestNotifications(filter);
  }

  getUnseenNotificationsCount(): Observable<number> {
    return this._notificationsApi.getUnseenNotificationsCount();
  }

  markNotificationAsRead(notificationId: string): Observable<string> {
    return this._notificationsApi.markNotificationAsRead(notificationId);
  }

  updateAdminNotificationToken(notificationToken: string): Observable<string> {
    return this._notificationsApi.updateAdminNotificationToken(notificationToken);
  }
}
